<!-- <sm-svg-loader *ngIf="loader"></sm-svg-loader> -->



<!-- Mobile design start-->
<div class="">
   <div class="booking_card_open">
      <mat-card (click)="viewAll()"> 
          <div class="header_cardf_drd">
              <div class="todays_booking_logo">
               <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 32 32" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M10.8 2.3c-.2-.2-.4-.3-.7-.3-.3 0-.5.1-.7.3l-6 6c-.4.4-.4 1 0 1.4.2.2.5.3.7.3s.5-.1.7-.3l4.3-4.3L9 29c0 .6.4 1 1 1s1-.4 1-1l.1-23.5 4.1 4.2c.4.4 1 .4 1.4 0s.4-1 0-1.4zM22 2c-.6 0-1 .4-1 1l-.1 23.5-4.1-4.3c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l5.8 6.1c.2.2.4.3.7.3.3 0 .5-.1.7-.3l6-6.1c.4-.4.4-1 0-1.4s-1-.4-1.4 0l-4.3 4.3L23 3c0-.5-.4-1-1-1z" fill="#d70699" opacity="1" data-original="#000000" class=""></path></g></svg>
              </div>
              <div class="todays_parat">
                  <h3 *ngIf="!loader">{{employeeLogData?.total_dutylogs ? employeeLogData?.total_dutylogs : 0}}</h3>
                  <svg *ngIf="loader" class="cust_svg"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin:auto;background: transparent; display:block;" width="54px" height="54px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                    <g transform="rotate(0 50 50)">
                      <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#f20c49">
                        <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.9166666666666666s" repeatCount="indefinite"></animate>
                      </rect>
                    </g><g transform="rotate(30 50 50)">
                      <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#f20c49">
                        <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.8333333333333334s" repeatCount="indefinite"></animate>
                      </rect>
                    </g><g transform="rotate(60 50 50)">
                      <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#f20c49">
                        <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.75s" repeatCount="indefinite"></animate>
                      </rect>
                    </g><g transform="rotate(90 50 50)">
                      <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#f20c49">
                        <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.6666666666666666s" repeatCount="indefinite"></animate>
                      </rect>
                    </g><g transform="rotate(120 50 50)">
                      <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#f20c49">
                        <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.5833333333333334s" repeatCount="indefinite"></animate>
                      </rect>
                    </g><g transform="rotate(150 50 50)">
                      <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#f20c49">
                        <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.5s" repeatCount="indefinite"></animate>
                      </rect>
                    </g><g transform="rotate(180 50 50)">
                      <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#f20c49">
                        <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.4166666666666667s" repeatCount="indefinite"></animate>
                      </rect>
                    </g><g transform="rotate(210 50 50)">
                      <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#f20c49">
                        <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.3333333333333333s" repeatCount="indefinite"></animate>
                      </rect>
                    </g><g transform="rotate(240 50 50)">
                      <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#f20c49">
                        <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.25s" repeatCount="indefinite"></animate>
                      </rect>
                    </g><g transform="rotate(270 50 50)">
                      <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#f20c49">
                        <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.16666666666666666s" repeatCount="indefinite"></animate>
                      </rect>
                    </g><g transform="rotate(300 50 50)">
                      <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#f20c49">
                        <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.08333333333333333s" repeatCount="indefinite"></animate>
                      </rect>
                    </g><g transform="rotate(330 50 50)">
                      <rect x="47" y="24" rx="3" ry="6" width="6" height="12" fill="#f20c49">
                        <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"></animate>
                      </rect>
                    </g>
                    </svg>
              </div>
          </div>
          <div class="apploint_set_prp">
              <h3>Employee In/Out</h3>
              <p>In: {{employeeLogData?.total_dutyin ? employeeLogData?.total_dutyin : 0}}
              </p>
              <p>Out: {{employeeLogData?.total_dutyout ? employeeLogData?.total_dutyout : 0}}</p>
          </div>
          <div class="arrow_crdf" *ngIf="employeeLogData?.total_dutylogs > 0">
            <mat-icon>arrow_forward</mat-icon>
          </div>
      </mat-card>
   </div>
  </div>
  <!-- Mobile design end-->